export const H_PADDING_MOBILE = '24px';